import { connect, ConnectedProps } from 'react-redux';
import { AppState } from '../../../redux/reducers';
import * as SettlementStore from '../../../redux/middleware/SettlementMiddleware';
import { Settlement } from '../../../models/Entities/Settlements/Settlement';

export interface IProps {
    SettlementId: number;
    isOpen: boolean;
    onClose: () => void;
}

const mapStateToProps = (state: AppState, ownProps: IProps) => ({
    Settlement: state.Settlement?.list?.find((item: Settlement) => item.id === ownProps.SettlementId) as Settlement | undefined,
    isUpdating: state.Settlement?.isUpdatingOne || false,
    updatedOk: state.Settlement?.successUpdatingOne === true,
    failOnUpdating: state.Settlement?.failOnUpdatingOne || false,
    error: state.Settlement?.error
});

const mapDispatchToProps = {
    RenameSettlement: SettlementStore.actionCreators.RenameSettlement
};

export const connector = connect(mapStateToProps, mapDispatchToProps);
export type Props = IProps & ConnectedProps<typeof connector>;
